import { cn } from '@/shared/lib/cn';
import type { ProgressStep } from './progressModel';

const MARK: Record<ProgressStep['state'], string> = {
  completed: 'bg-mint text-forest-deep',
  open: 'bg-amber-tint text-amber-ink',
  current: 'bg-forest-deep text-white',
  future: 'border-[1.5px] border-white/40 text-white',
  cancelled: 'bg-sealwax text-white',
  skipped: 'border-[1.5px] border-white/25 text-white/60',
  unavailable: 'border-[1.5px] border-white/25 text-white/60',
};

/** Für Vorleser: der Zustand steht sonst nur im versteckten Zeichen. */
const STATE_WORD: Record<ProgressStep['state'], string> = {
  completed: 'erledigt',
  open: 'offen',
  current: 'aktuell',
  future: 'noch nicht',
  cancelled: 'abgebrochen',
  skipped: 'übersprungen',
  unavailable: 'nicht sichtbar',
};

const SYMBOL: Partial<Record<ProgressStep['state'], string>> = {
  completed: '✓',
  open: '!',
  cancelled: '✕',
  unavailable: '–',
};

/** Die vier Schritte im Kopf; auf dem Handy seitlich wischbar. */
export function BookingHeroSteps({
  steps,
  stepSubs,
}: {
  steps: ProgressStep[];
  stepSubs: Record<string, string>;
}) {
  return (
    <ol aria-label="Stand der Buchung" className="scrollbar-none flex gap-1 overflow-x-auto">
      {steps.map((step, index) => (
        <li
          key={step.id}
          aria-current={step.state === 'current' ? 'step' : undefined}
          className={cn(
            'rounded-control flex min-w-0 flex-none items-center gap-2 py-2 pl-2 pr-3',
            step.state === 'current' && 'text-forest-deep bg-white',
          )}
        >
          <span
            aria-hidden
            className={cn(
              'rounded-pill flex size-[26px] flex-none items-center justify-center text-[13px] font-extrabold',
              MARK[step.state],
            )}
          >
            {SYMBOL[step.state] ?? index + 1}
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-[13px] font-bold">
              {step.label}
              <span className="sr-only">: {STATE_WORD[step.state]}</span>
            </span>
            {stepSubs[step.id] && (
              <span className="text-[11px] opacity-80">{stepSubs[step.id]}</span>
            )}
          </span>
        </li>
      ))}
    </ol>
  );
}
